import { MAX_GRID_WIDTH } from "config/styleConsts";
import { Box, SimpleGrid } from "@chakra-ui/react";
import type { BoxProps } from "@chakra-ui/react";

export const Grid = ({ children, ...props }: BoxProps) => (
  <Box
    w="full"
    maxW={MAX_GRID_WIDTH}
    px={{ base: 4, lg: 4, xl: "unset" }}
    mb={{ base: 16, md: 32 }}
    mx="auto"
    {...props}
  >
    <SimpleGrid columns={{ base: 1, md: 12 }} spacing={8}>
      {children}
    </SimpleGrid>
  </Box>
);
